import classNames from 'classnames'

export default function BracketSet({
	id,
	identifier,
	round,
	totalGames,
	slots,
}) {
	function isWinner(totalGames, score) {
		return score > totalGames / 2
	}

	return (
		<div
			className={`relative m-3 bracketSet bracketIdentifier_${identifier} text-white`}
		>
			{slots.map((slot) => (
				<div className="flex flex-row min-w-36 max-w-[164px] border border-gray-700 bg-[#242424]">
					<div
						className={classNames(
							isWinner(totalGames, slot.entrant.score) &&
								'font-bold',
							'h-6 w-36 overflow-hidden text-ellipsis whitespace-nowrap',
						)}
					>
						{slot.entrant.name}
					</div>
					<div
						className={classNames(
							'h-6 w-6 text-center float-right bg-neutral-700 font-bold',
						)}
					>
						{slot.entrant.score}
					</div>
				</div>
			))}
			<div className="absolute w-4 h-6 top-3 -left-4 bg-[#242424] border text-center border-gray-700">
				{identifier}
			</div>

			{/* <div className="absolute bg-transparent w-3 h-3 top-5 left-[134px]" style={{backgroundImage: 'url(data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cdefs%3E%3Cstyle%3E.c%7Bfill%3A%23616161%7D.i%7Bfill%3A%23fff%7D%3C%2Fstyle%3E%3C%2Fdefs%3E%3Ccircle%20class%3D%22c%22%20cx%3D%226%22%20cy%3D%226%22%20r%3D%226%22%2F%3E%3Cpolygon%20class%3D%22i%22%20points%3D%224%205%204%206%205%206%205%209%204%209%204%2010%208%2010%208%209%207%209%207%202%205%202%205%204%207%204%207%205%204%205%22%2F%3E%3C%2Fsvg%3E)'}}></div> */}
		</div>
	)
}
